"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TextArea = antd_1.Input.TextArea;
var CardRowTextAreaEditor = /** @class */ (function (_super) {
    __extends(CardRowTextAreaEditor, _super);
    function CardRowTextAreaEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = {
            width: '100%',
            textAlign: 'center',
            boxShadow: "none",
            padding: "10px"
        };
        return _this;
    }
    CardRowTextAreaEditor.prototype.onValueChange = function (e) {
        if (this.props.onValueChanged) {
            this.props.onValueChanged(e.target.value);
        }
    };
    CardRowTextAreaEditor.prototype.getRequiredMark = function () {
        if (this.props.required) {
            return (React.createElement("div", { style: { color: "#FF0000", marginRight: "2px" } }, "*"));
        }
        return (null);
    };
    CardRowTextAreaEditor.prototype.getErrorMessage = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return (React.createElement("div", { style: {
                        color: "#FF0000",
                        fontSize: "10px",
                        textAlign: "left"
                    } }, this.props.rules.errorMessage));
            }
        }
        return null;
    };
    CardRowTextAreaEditor.prototype.getCSSStyle = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return {
                    borderColor: "#FF0000",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    borderRadius: "4px",
                    resize: "none",
                    textAlign: "left",
                    overflow: "vertical"
                };
            }
        }
        return {
            resize: "none",
            textAlign: "left",
            overflow: "vertical"
        };
    };
    CardRowTextAreaEditor.prototype.getTitleRenderObject = function () {
        return (React.createElement("div", { style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center"
            } },
            this.getRequiredMark(),
            React.createElement("div", { style: {
                    fontSize: "14px",
                    textAlign: "left",
                    color: "rgba(0,0,0,.65)",
                    fontWeight: 400
                } }, this.props.texts.caption)));
    };
    CardRowTextAreaEditor.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            this.getTitleRenderObject(),
            React.createElement(antd_1.Input.Group, { compact: true },
                React.createElement(TextArea, { placeholder: this.props.texts.placeholder, onChange: this.onValueChange.bind(this), value: this.props.value, disabled: this.props.disabled, style: this.getCSSStyle(), rows: this.props.rowsCount })),
            this.getErrorMessage()));
    };
    return CardRowTextAreaEditor;
}(React.Component));
exports.default = CardRowTextAreaEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowTextAreaEditor.tsx
// module id = 90
// module chunks = 0